<template>
  <div id="AnswerList" class="not-full">
    <div class="answer-section"
         :key="index"
         :id="'Answer-'+answer.uuid"
         v-for="(answer, index) in answers"><!--v-inview:animate="'fadeIn'"-->
      <div class="arrow">
        <div class="nieum"></div>
      </div>
      <div class="answer">
        <Answer :mode="'detail'"
                :answer="answer"
                :isLast = "index==answers.length"
                @editAnswer="editAnswer"
                @removeAnswer="removeAnswer"/>
      </div>
      <div class="line" v-if="index!=answers.length-1"></div>
    </div>
  </div>
</template>

<script>
// Components Section
import Answer from './Answer'

// Variable Section
// let self

export default {
  name: 'AnswerList',
  props: ['answers'],
  components: {
    Answer
  },
  data: function () {
    return {
    }
  },
  computed: {},
  created() {
  },
  destroyed() {},
  methods: {
    editAnswer(answer) {
      this.$emit('editAnswer', answer)
    },
    removeAnswer(answer) {
      this.$emit('removeAnswer', answer)
    }
  },
}
</script>

<style lang="scss" scoped>
  #AnswerList {
    width: 100%;
    .answer-section {
      width: 100%;
      padding-top: 20px;
      .arrow {
        width: 22px;
        .nieum {
          width: 13px;
          height: 15px;
          border-style: solid;
          border-color: #b9c1cc;
          border-left-width: 1px;
          border-bottom-width: 1px;
          margin-top: 4px;
        }
      }
      .answer {
        width: calc(100% - 22px);
      }
    }
    .line {
      width: 100%;
      height: 1px;
      border: dashed 1px #d7e1ea;
      margin-top: 20px;
    }
  }
</style>
